import { render, staticRenderFns } from "./schoolReports.vue?vue&type=template&id=b88ee1e8&scoped=true"
import script from "./schoolReports.vue?vue&type=script&lang=js"
export * from "./schoolReports.vue?vue&type=script&lang=js"
import style0 from "./schoolReports.vue?vue&type=style&index=0&id=b88ee1e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88ee1e8",
  null
  
)

export default component.exports